import { browserEffectRuntime } from "@crm/effect/client/runtime";
import { rpcCaller } from "@crm/rpc-client";
import { CheckStudentAccessRpc } from "@crm/rpc-contract/groups/check-student-access";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Data, Effect } from "effect";
import { studentDetailSearchSchema } from "./-lib/search-schema";

class StudentDetailRouteWorkflowError extends Data.TaggedError("StudentDetailRouteWorkflowError")<{
  readonly message: string;
  readonly cause?: unknown;
}> {}

function promiseStudentDetailRouteEffect<A>(
  run: () => PromiseLike<A>,
  fallbackMessage: string,
): Effect.Effect<A, StudentDetailRouteWorkflowError> {
  return Effect.tryPromise({
    try: run,
    catch: (cause) => toStudentDetailRouteWorkflowError(cause, fallbackMessage),
  });
}

function toStudentDetailRouteWorkflowError(
  cause: unknown,
  fallbackMessage: string,
): StudentDetailRouteWorkflowError {
  return new StudentDetailRouteWorkflowError({
    message: cause instanceof Error ? cause.message : fallbackMessage,
    cause,
  });
}

function studentDetailLoaderEffect(
  studentId: string,
): Effect.Effect<void, StudentDetailRouteWorkflowError> {
  return promiseStudentDetailRouteEffect(
    () => rpcCaller(CheckStudentAccessRpc).checkStudentAccess({ studentId }),
    "检查学员访问权限失败",
  ).pipe(Effect.asVoid);
}

export const Route = createFileRoute("/_protected/students/$studentId/")({
  head: () => ({
    meta: [{ title: "学员详情 · imiker CRM" }],
  }),
  validateSearch: studentDetailSearchSchema,
  search: {
    middlewares: [stripSearchParams({ tab: "enrollments" as const })],
  },
  loader: ({ params }) =>
    browserEffectRuntime.runPromise(studentDetailLoaderEffect(params.studentId))
});
